import axios from 'axios'
// axios 配置
axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
import {
  localToken
} from '@/libs/util';
import globConfig from '@/config/config';
import {
  Message
} from 'element-ui'
import common from "@/libs/common";
class HttpRequest {
  constructor(baseUrl = baseUrl,baseUrl2 = baseUrl2,baseUrl3 = baseUrl3,baseUrl4 = baseUrl4) {
    this.baseUrl = baseUrl;
    this.baseUrl2 = baseUrl2;
    this.baseUrl3 = baseUrl3;
    this.baseUrl4 = baseUrl4;
    this.queue = {}
  }

  getInsideConfig(url) {
    // debugger
    return {
      // baseURL: url?(url=="/weather"?this.baseUrl3:(url=="/rbac"?this.baseUrl4:this.baseUrl2)):this.baseUrl,
      baseURL:this.baseUrl,
      withCredentials: url=="/weather"?false:true,
      headers: {}
      // timeout:50000,
    };
  }

  distroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {}
  }

  getWhite(url){
      let whiteMethod = false;
      let whiteMethodList = globConfig.apiWhite || [];
      for (let i = 0; i < whiteMethodList.length; i++) {
        if (url.indexOf(whiteMethodList[i]) > -1) {
          whiteMethod = true;
          break;
        }
      }
      return whiteMethod
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true;
      //是否无需access_token 的方法 start
      let whiteMethod = this.getWhite(url);
      if (whiteMethod) { //白名单方法 无需token
        if(url.indexOf('/api/?version') > -1){
          // axios.defaults.withCredentials = false; //让ajax携带cookie
        }else{
          config.headers.__tenant = localToken.getTenant();
          // axios.defaults.withCredentials=true;//让ajax携带cookie
        }
        config.headers.Authorization = "";
      } else {
        config.headers.__tenant = localToken.getTenant();
        // axios.defaults.withCredentials=false;//让ajax携带cookie
        //获取本地存放的token
        let access_token = localToken.getToken();
        if (!access_token) { //token有问题
          localToken.clearLocal();
          setTimeout(() => {
            window.location.reload()
          }, 500)
          return Promise.reject('登录状态无效，请重新登录')
        }
        config.headers.Authorization = access_token;
      }
      return config
    }, error => {
      return Promise.reject(error)
    });

    // 响应拦截
    instance.interceptors.response.use(res => {
      console.log(res, '响应数据');
      this.distroy(url);
      let data = res.data;
      let whiteMethod = this.getWhite(url);
      if(whiteMethod){
        if (url.indexOf('request-token-by-open-id') > -1) {
          if (typeof res.status !== 'undefined' && res.status === 200 && typeof data.accessToken !== 'undefined' && data.accessToken !== null) {
            let token =
            data.tokenType + " " + data.accessToken || ""; //token值
            let expires = data.expiresIn || 7200;
            localToken.setToken(token, expires); //存储token（已经登录的token）
            // localToken.setUser(res.data.entity.nickName || "");
            localToken.setDomains(common.domains);
          }
          return data
        }else if (url.indexOf('application-configuration') > -1) {
          if (typeof res.status !== 'undefined' && res.status === 200 && typeof data.auth !== 'undefined' && data.auth !== null) {
            //let policies = data.auth.policies; // 所有权限
            let grantedPolicies = data.auth.grantedPolicies; // 现有权限
            let permissGroup = [];
            for (let key of Object.keys(grantedPolicies)) {
              if(key.indexOf('Intelligent') > -1){
                permissGroup = [...permissGroup,key]
              }
            }
            // let permissGroup = [
            // // "Intelligent.ProductABC",
            // // "Intelligent.ProductABC.Set",
            // "Intelligent.DispatchCenter",
            // "Intelligent.DispatchCenter.Export",
            // "Intelligent.DispatchCenter.Set",
            // "IntelligentDispatchCenter.ModeDelivery",
            // "IntelligentDispatchCenter.Warning",
            // "IntelligentDispatchCenter.Warning.SetParams",
            // "IntelligentDispatchCenter.Warning.Export",
            // "Intelligent.PriceAnalysis",
            // "Intelligent.TimeSaleAnalysis",
            // "Intelligent.DataBrain"]
            localToken.setConfiguration(JSON.stringify({"Intelligent":permissGroup}));
          }
          return data
        } else if(typeof res.status !== 'undefined' && res.status === 200){
          return data;
        } else if(typeof res.status !== 'undefined' && res.status===204){
          return true;
        } else {
          return Promise.reject(data);
        }
      }
      else if (res.status === 200) {
        if (url.indexOf('application-configuration') > -1) {
          if (typeof res.status !== 'undefined' && res.status === 200 && typeof data.auth !== 'undefined' && data.auth !== null) {
            //let policies = data.auth.policies; // 所有权限
            let grantedPolicies = data.auth.grantedPolicies; // 现有权限
            let permissGroup = [];
            for (let key of Object.keys(grantedPolicies)) {
              if(key.indexOf('Intelligent') > -1){
                permissGroup = [...permissGroup,key]
              }
            }
            // let permissGroup = [
            // // "Intelligent.ProductABC",
            // // "Intelligent.ProductABC.Set",
            // "Intelligent.DispatchCenter",
            // "Intelligent.DispatchCenter.Export",
            // "Intelligent.DispatchCenter.Set",
            // "IntelligentDispatchCenter.ModeDelivery",
            // "IntelligentDispatchCenter.Warning",
            // "IntelligentDispatchCenter.Warning.SetParams",
            // "IntelligentDispatchCenter.Warning.Export",
            // "Intelligent.PriceAnalysis",
            // "Intelligent.TimeSaleAnalysis",
            // "Intelligent.DataBrain"]
            localToken.setConfiguration(JSON.stringify({"Intelligent":permissGroup}));
          }
          return data
        
      }
      else
{
  console.log('api正确返回数据', res.data);
        return res.data.entity || [];
}


    } 
      else {
        console.log('来这里了');
        return Promise.reject(data);
      }
    }, error => {
      let whiteMethod = this.getWhite(url);
      if(whiteMethod){
        return error.response.data.error || [];
      }
      this.distroy(url);
      return Promise.reject(error)
    })
  }

  //通用请求
  request(options,url='') {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(url), options);
    this.interceptors(instance, options.url);
    return instance(options)
  }

  //增加几种常用方式
  get(options,url='') {
    options = Object.assign({
      method: 'get'
    }, options);
    return this.request(options,url);
  }

  post(options,url='') {
    options = Object.assign({
      method: 'post'
    }, options);
    return this.request(options,url);
  }

  put(options,url='') {
    options = Object.assign({
      method: 'put'
    }, options);
    return this.request(options,url);
  }

  del(options,url='') {
    options = Object.assign({
      method: 'delete'
    }, options);
    return this.request(options,url);
  }

  path(options,url='') {
    options = Object.assign({
      method: 'path'
    }, options);
    return this.request(options,url);
  }

  parseParams(data) {
    try {
      let tempArr = [];
      for (let i in data) {
        let key = encodeURIComponent(i);
        let value = encodeURIComponent(data[i]);
        tempArr.push(key + '=' + value);
      }
      return tempArr.join('&');

    } catch (err) {
      return '';
    }
  }

}

export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/api.axios.js